import axios from 'axios';
import { useEffect, useState } from 'react';

const EMPTY_SUGGESTIONS = [];

export default function useEntitySearchSuggestions(path) {
    const [result, setResult] = useState({ path: null, suggestions: EMPTY_SUGGESTIONS, isLoading: false });

    useEffect(() => {
        if (!path) return;

        let active = true;
        setResult({ path, suggestions: EMPTY_SUGGESTIONS, isLoading: true });
        axios.get(path)
            .then(({ data }) => {
                if (active) {
                    setResult({ path, suggestions: data.searchSuggestions || EMPTY_SUGGESTIONS, isLoading: false });
                }
            })
            .catch((error) => {
                if (active) {
                    console.log(error);
                    setResult({ path, suggestions: EMPTY_SUGGESTIONS, isLoading: false });
                }
            });

        return () => { active = false; };
    }, [path]);

    return result.path === path ? result : {
        suggestions: EMPTY_SUGGESTIONS,
        isLoading: !!path,
    };
}
